import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  useTheme,
  Theme,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./ExamPage.scss";
import Report from "./ImageExamPage/Exampageresport.png";
import paperlist from "./ImageExamPage/paperexamlist.png";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listUserExamList } from "../../Redux/Slices/UserPackage/ListUserExamListSlice";
import { clearListExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { listInstructionExamID } from "../../Redux/Slices/Exam/ListinstructionExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { ILoginResponse } from "../Login/ILogin";
import { decode } from "../../Utils/encodeDecode";

interface AccordionExamProps {
  exam: {
    title: string;
    description: string;
  };
}

const SinglePageLayout: React.FC = () => {
  const theme: Theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [selectedIndex, setSelectedIndex] = useState(0);

  const { data: listUserExamListSlice } = useAppSelector(
    (state) => state.ListUserExamListSlice
  );
  const Packagess: any = Array.isArray(listUserExamListSlice?.data)
    ? listUserExamListSlice?.data
        .filter((user) => !user.expired) // Filter out courses where expiry is false
        .map((user, index) => ({
          ...user,
          index: index + 1,
        }))
    : [];
  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    dispatch(listUserExamList());
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  return (
    <div className="ExamStudentAlingment">
      <div className="DashboardStudent">Full Length Mock Exam</div>
      <div className="exam-container_exam">
        <div className="subfirst">
          <Typography variant="h6" fontWeight="bold" className="examlistinpage">
            Courses
          </Typography>
          <div
            className="Exampagecard"
            style={{ overflowY: "auto", height: "100%" }}
          >
            {Packagess && Packagess?.length > 0 ? (
              Packagess?.map((pkg: any, index: any) => (
                <Card
                  key={index}
                  onClick={() => setSelectedIndex(index)}
                  sx={{
                    margin: 2,
                    cursor: "pointer",
                    background:
                      selectedIndex === index
                        ? "linear-gradient(to right, #007bff, #66b2ff)"
                        : "#fff",
                    color: selectedIndex === index ? "#fff" : "#000",
                    borderRadius: 2,
                    boxShadow: 2,
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="body1"
                      align="center"
                      className="Exampageheading"
                      fontWeight={600}
                    >
                      {pkg?.course_name}
                    </Typography>
                  </CardContent>
                </Card>
              ))
            ) : (
              <Card
                sx={{
                  margin: 2,
                  cursor: "pointer",
                  background: "linear-gradient(to right, #007bff, #66b2ff)",
                  color: "#fff",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <CardContent>
                  <Typography
                    variant="body1"
                    align="center"
                    className="Exampageheading"
                    fontWeight={600}
                    sx={{ marginBottom: "10px" }}
                  >
                    No Course Available
                  </Typography>
                  <Typography variant="body2" align="center">
                    You don't have any course at the moment.
                  </Typography>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
        <div className="subsecond">
          {" "}
          <Typography variant="h6" fontWeight="bold" className="examlistinpage">
            Exam
          </Typography>
          {Packagess?.[selectedIndex]?.exams?.length > 0 ? (
            Packagess[selectedIndex]?.exams?.map(
              (listexam: any, examIndex: any) => (
                <Accordion
                  defaultExpanded
                  key={examIndex}
                  sx={{ boxShadow: "none" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ margin: "0px 0px", height: "45px", minHeight: 0 }}
                  >
                    <Typography
                      variant="h6"
                      className="headingexampagesub"
                      sx={{ minHeight: 0 }}
                    >
                      {listexam?.exam_name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      variant="body2"
                      className="despestionexamlistinpage"
                      sx={{ marginBottom: 1 }}
                    >
                      {listexam?.exam_description}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2" className="listweight">
                        Attempt Count: {listexam?.retake_count}
                      </Typography>
                      <div>
                        {listexam?.student_exam_id === null ? null : (
                          <Button
                            variant="contained"
                            color="inherit"
                            className="despestiongebutton"
                            onClick={() => {
                              navigate("/examresult", {
                                state: listexam?.student_exam_id,
                              });
                            }}
                          >
                            <img
                              src={Report}
                              alt="Report"
                              style={{ marginRight: "5px" }}
                            />
                            View Report
                          </Button>
                        )}

                        <Button
                          variant="contained"
                          color="primary"
                          className="despestionexamlistinpagebutton"
                          onClick={() => {
                            dispatch(clearListExamID());
                            dispatch(
                              listInstructionExamID({
                                exam_id: listexam?.exam_id,
                              })
                            );
                            dispatch(
                              addStudentExam({
                                exam_id: listexam?.exam_id,
                                student_id: details?.id,
                                closed: false,
                              })
                            );
                            navigate("/instruction", {
                              state: listexam?.exam_id,
                            });
                          }}
                        >
                          <img
                            src={paperlist}
                            alt="Report"
                            style={{ marginRight: "5px" }}
                          />
                          {listexam?.retake_count === 0
                            ? "Start Now"
                            : "Retake Exam"}
                        </Button>
                      </div>
                    </Box>
                  </AccordionDetails>
                  <Divider />
                </Accordion>
              )
            )
          ) : (
            <Accordion defaultExpanded sx={{ boxShadow: "none" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ margin: "0px 0px", height: "45px", minHeight: 0 }}
              >
                <Typography
                  variant="h6"
                  className="headingexampagesub"
                  sx={{ minHeight: 0 }}
                >
                  No Exam Available
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="body2"
                  className="despestionexamlistinpage"
                  sx={{ marginBottom: 1 }}
                >
                  You don't have any exam at the moment. Please attempt a test
                  to see your progress here.
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className="despestionexamlistinpagebutton"
                    onClick={() => {
                      navigate("/examprogress");
                    }}
                  >
                    Back to resume exam
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
        </div>
      </div>
    </div>
  );
};

export default SinglePageLayout;
